import React from 'react'
import PropTypes from 'prop-types'
import SankeyChart from './SankeyChart'

export default class AggrChart extends React.Component {
  static propTypes = {
    nodes: PropTypes.array,
    links: PropTypes.array
  }

  state = {width: window.innerWidth - 280, height: 800}

  // eslint-disable-next-line react/sort-comp
  updateDimensions = () => {
    this.setState({width: window.innerWidth - 280})
  }

  componentDidMount() {
    this.updateDimensions()
    window.addEventListener('resize', this.updateDimensions)
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  render() {
    const {nodes, links} = this.props
    const {width, height} = this.state

    if (!nodes.length || !links.length) {
      return null
    }

    return <SankeyChart nodes={nodes} links={links} size={{width, height}} />
  }
}



// WEBPACK FOOTER //
// ./client/views/AggreatedAttributionView/AggrChart/AggrChart.js